import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function PricingSection() {
  const features = ['Bespoke label design service', 'Full wine selection access — reds, whites, rosé & sparkling', 'Premium textured paper & foil options', 'Custom packaging options', 'Dedicated design consultant', 'Event coordination support', 'Delivery included'];
  return <section id="pricing" className="py-24 bg-cream" data-id="element-225">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-226">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-227">
          <span className="text-wine font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-228">
            Pricing
          </span>
          <h2 className="font-playfair text-4xl md:text-5xl text-charcoal font-bold mb-6" data-id="element-229">
            Tailored to{' '}
            <span className="italic text-wine font-normal" data-id="element-230">Your Needs</span>
          </h2>
          <p className="text-lg text-brown/70" data-id="element-231">
            Every project is unique. Pricing is based on your wine selection,
            quantity, and label design — so you only pay for what you need.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} className="max-w-lg mx-auto" data-id="element-232">
          <div className="relative bg-white rounded-sm ring-2 ring-wine shadow-xl p-10" data-id="element-233">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-wine text-white text-xs font-bold uppercase tracking-wider py-1 px-4 rounded-full shadow-md" data-id="element-234">
              Bespoke Service
            </div>

            <div className="text-center mb-8" data-id="element-235">
              <h3 className="font-playfair text-3xl font-bold text-charcoal mb-2" data-id="element-236">
                Custom
              </h3>
              <p className="text-brown/60 text-sm" data-id="element-237">
                Tailored solutions for every occasion — from intimate gatherings
                to large-scale events.
              </p>
            </div>

            <div className="text-center mb-8" data-id="element-238">
              <div className="flex items-baseline justify-center text-charcoal" data-id="element-239">
                <span className="text-4xl font-bold font-playfair" data-id="element-240">
                  Quote-Based
                </span>
              </div>
              <div className="text-sm font-medium text-wine mt-3 bg-wine/5 inline-block px-4 py-1.5 rounded-sm" data-id="element-241">
                Based on quantity & wine selection
              </div>
            </div>

            <div className="w-full h-px bg-cream-200 mb-8" data-id="element-242"></div>

            <ul className="space-y-4 mb-10" data-id="element-243">
              {features.map((feature, fIndex) => <li key={fIndex} className="flex items-start" data-id="element-244">
                  <CheckIcon className="w-5 h-5 mr-3 flex-shrink-0 text-wine" data-id="element-245" />
                  <span className="text-brown/80 text-sm" data-id="element-246">{feature}</span>
                </li>)}
            </ul>

            <a href="/design" className="block w-full py-3.5 px-4 rounded-sm font-medium transition-colors duration-300 bg-wine text-white hover:bg-wine-700 text-center" data-id="element-247">
              Request a Quote
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}